// بیمه نامه‌های خودرو
import React, { useState, useEffect } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { usePagedList, CountBadge } from '../../components/paging';
import { ExcelButton } from '../../components/excel';
import WarningDialog from '../../components/WarningDialog';
import { openReport } from '../../components/report';
import { useFormButtons } from '../../utils/vbPerms';
import {
  API, qs, toFa, fmtAmt, Grid, Field, TextIn, DateIn, Lookup, Modal, DeleteDialog, MsgDialog, excelCols, smallBtn,
} from './carsShared';

const BUTTONS = ['BTNNEW', 'BTNEDIT', 'BTNDELETE', 'BTNOK', 'BTNCANCEL', 'BTNNEWREQUEST', 'BTNINSUREREQUEST', 'BTNINSURECONFIRM'];
const KINDS = ['بیمه شخص ثالث', 'بیمه بدنه'];
const num = v => Number(String(v ?? '').replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)).replace(/,/g, '')) || 0;

const blank = (keep = {}) => ({
  insure_kind: 0, serial_no: '', insure_no: '', issue_date: '', from_date: '', to_date: '', insure_cost: '', added_tax: '',
  remark: '', request_no: '', request_date: '', confirm_no: '', confirm_date: '',
  receiver: { id: 0, title: '' }, asker: { id: 0, title: '' }, department: { id: 0, title: '' }, ...keep,
});

function rowToForm(r) {
  return blank({
    insure_kind: r.InsureKind || 0, serial_no: r['شماره سریال'] || '', insure_no: r['شماره بیمه نامه'] || '',
    issue_date: r['تاریخ صدور'] || '', from_date: r['از تاریخ'] || '', to_date: r['تا تاریخ'] || '',
    insure_cost: r['مبلغ بیمه'] ?? '', added_tax: r['مالیات بر ارزش افزوده'] ?? '', remark: r['شرح تعهدات'] || '',
    request_no: r['شماره درخواست'] ?? '', request_date: r['تاریخ درخواست'] || '',
    confirm_no: r['شماره تاییدیه'] ?? '', confirm_date: r['تاریخ تاییدیه'] || '',
    receiver: { id: r.AmountReceiverId || 0, title: r['بیمه گزار'] || '' },
    asker: { id: r.AskerId || 0, title: r['درخواست کننده'] || '' },
    department: { id: r.DepartmentId || 0, title: r['واحد اجرایی'] || '' },
  });
}

function InsureForm({ form, F, showTax }) {
  return (
    <>
      <div style={ui.row}>
        <Field label="نوع بیمه نامه">
          <select value={form.insure_kind} onChange={e => F('insure_kind', Number(e.target.value))} style={ui.input}>
            {KINDS.map((k, i) => <option key={i} value={i}>{k}</option>)}
          </select>
        </Field>
        <Field label="شماره سریال"><TextIn num value={form.serial_no} onChange={v => F('serial_no', v)} /></Field>
        <Field label="شماره بیمه نامه"><TextIn num value={form.insure_no} onChange={v => F('insure_no', v)} /></Field>
        <Field label="تاریخ صدور"><DateIn value={form.issue_date} onChange={v => F('issue_date', v)} /></Field>
      </div>
      <div style={ui.row}>
        <Field label="کارگزار بیمه"><Lookup path="/insure/lookup/receiver/" value={form.receiver} onChange={v => F('receiver', v)} /></Field>
        <Field label="از تاریخ"><DateIn value={form.from_date} onChange={v => F('from_date', v)} /></Field>
        <Field label="تا تاریخ"><DateIn value={form.to_date} onChange={v => F('to_date', v)} /></Field>
      </div>
      <div style={ui.row}>
        <Field label="مبلغ"><TextIn num value={form.insure_cost} onChange={v => F('insure_cost', v)} /></Field>
        {showTax && <Field label="مالیات بر ارزش افزوده">
          <TextIn num value={form.added_tax} onChange={v => F('added_tax', v)} title="F11: محاسبه با درصد"
            onKeyDown={e => { if (e.key === 'F11' && num(form.added_tax) < 100) { e.preventDefault(); F('added_tax', Math.round(num(form.insure_cost) * num(form.added_tax) / 100)); } }} />
        </Field>}
        {showTax && <Field label="جمع"><TextIn num value={fmtAmt(num(form.insure_cost) + num(form.added_tax))} disabled onChange={() => {}} /></Field>}
      </div>
      <div style={ui.row}>
        <Field label="درخواست: شماره"><TextIn num value={form.request_no} onChange={v => F('request_no', v)} /></Field>
        <Field label="تاریخ"><DateIn value={form.request_date} onChange={v => F('request_date', v)} /></Field>
        <Field label="تایید: شماره"><TextIn num value={form.confirm_no} onChange={v => F('confirm_no', v)} /></Field>
        <Field label="تاریخ"><DateIn value={form.confirm_date} onChange={v => F('confirm_date', v)} /></Field>
      </div>
      <div style={ui.row}>
        <Field label="درخواست کننده"><Lookup path="/insure/lookup/people/" value={form.asker} onChange={v => F('asker', v)} /></Field>
        <Field label="واحد اجرایی"><Lookup path="/insure/lookup/department/" value={form.department} onChange={v => F('department', v)} /></Field>
      </div>
      <div style={ui.row}>
        <Field label="شرح تعهدات"><TextIn value={form.remark} onChange={v => F('remark', v)} /></Field>
      </div>
    </>
  );
}

export default function CarInsure({ user, onBack, carId, carTitle = '', year }) {
  const fb = useFormButtons('FRMCARINSURE', BUTTONS);
  const [cols, setCols] = useState([]);
  const [meta, setMeta] = useState({ show_tax: true });
  const [sel, setSel] = useState(null);
  const [req, setReq] = useState(null);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(blank());
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');
  const [newReq, setNewReq] = useState(false);
  const [askConfirm, setAskConfirm] = useState(false);
  const [saving, setSaving] = useState(false);

  const L = usePagedList((page) => API(`/insure/?${qs({ page, car_id: carId })}`)
    .then(j => { if (j.ok && page === 1) { setCols(j.columns || []); setMeta(j); } return j; }));
  const reload = () => L.reload({});
  useEffect(() => { if (fb.open) reload(); }, [fb.open]);

  useEffect(() => {
    setReq(null);
    if (!sel) return;
    API(`/insure/request-grid/?${qs({ request_no: sel['شماره درخواست'], request_date: sel['تاریخ درخواست'] })}`)
      .then(j => { if (j.ok && j.data.length) setReq(j); });
  }, [sel]);

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const openNew = async () => {
    const j = await API(`/insure/prepare/?${qs({ car_id: carId, mode: 'new', year })}`);
    if (!j.ok) { setMsg(j.msg); return; }
    setForm(blank({ receiver: meta.last_receiver || { id: 0, title: '' },
      request_no: j.request_no, request_date: j.request_date, confirm_no: j.confirm_no, confirm_date: j.confirm_date }));
    if (j.msgs && j.msgs.length) setMsg(j.msgs.join('\n'));
    setErr(''); setNewReq(true); setModal('new');
  };
  const openEdit = async () => {
    const j = await API(`/insure/prepare/?${qs({ car_id: carId, id: sel.CarInsureId, mode: 'edit' })}`);
    if (!j.ok) { setMsg(j.msg); return; }
    setForm(rowToForm(sel)); setErr(''); setNewReq(false); setModal('edit');
  };
  const newRequest = async () => {
    const j = await API(`/insure/new-request/?${qs({ request_date: form.request_date, confirm_date: form.confirm_date, year })}`);
    if (j.ok) {
      setForm(f => ({ ...f, request_no: j.request_no, request_date: j.request_date, confirm_no: j.confirm_no, confirm_date: j.confirm_date }));
      if (j.msgs && j.msgs.length) setMsg(j.msgs.join('\n'));
    }
  };
  const save = async () => {
    setSaving(true); setErr('');
    const body = JSON.stringify({ ...form, car_id: carId, receiver_id: form.receiver.id, asker_id: form.asker.id, department_id: form.department.id });
    const y = year ? `?year=${year}` : '';
    const j = modal === 'new'
      ? await API(`/insure/create/${y}`, { method: 'POST', body })
      : await API(`/insure/${sel.CarInsureId}/update/${y}`, { method: 'PUT', body });
    setSaving(false);
    if (!j.ok) { setErr(j.msg); if (j.new_request) setNewReq(true); return; }
    setModal(null); reload();
  };
  const doDelete = async () => {
    setModal(null);
    const j = await API(`/insure/${sel.CarInsureId}/delete/`, { method: 'DELETE' });
    if (!j.ok) setMsg(j.msg); else { setSel(null); reload(); }
  };
  const report = async (key, params) => { try { await openReport(key, params); } catch (e) { setMsg(e.message); } };
  const has = !!sel;

  const toolbar = fb.open ? (
    <>
      <div style={ui.toolBtns}>
        {fb.can('BTNNEW') && <button onClick={openNew} style={ui.btnNew}>＋ جدید</button>}
        {fb.can('BTNEDIT') && <button disabled={!has} onClick={openEdit} style={{ ...ui.btnEdit, opacity: has ? 1 : 0.4 }}>✎ ویرایش</button>}
        {fb.can('BTNDELETE') && <button disabled={!has} onClick={() => setModal('delete')} style={{ ...ui.btnDel, opacity: has ? 1 : 0.4 }}>✕ حذف</button>}
      </div>
      {fb.can('BTNINSUREREQUEST') && <button disabled={!has} onClick={() => report('tadarokat.car_insure_request', { request_no: sel['شماره درخواست'], request_date: sel['تاریخ درخواست'] })} style={{ ...smallBtn(), opacity: has ? 1 : 0.4 }}>برگه درخواست</button>}
      {fb.can('BTNINSURECONFIRM') && <button disabled={!has} onClick={() => setAskConfirm(true)} style={{ ...smallBtn(), opacity: has ? 1 : 0.4 }}>تاییدیه</button>}
      <CountBadge shown={L.data.length} total={L.pager.total} loading={L.loading} unit="بیمه نامه" />
      <ExcelButton title="بیمه خودروها" subtitle={carTitle || meta.car_title} columns={excelCols(cols, L.data)} rows={L.data} />
    </>
  ) : null;

  const confirmParams = (c) => ({ confirm_no: sel['شماره تاییدیه'], confirm_date: sel['تاریخ تاییدیه'], request_date: sel['تاریخ درخواست'], is_confirm: c });

  return (
    <>
      <ListPage user={user} onBack={onBack} title={`بیمه نامه ${meta.car_title || carTitle}`} subtitle="تدارکات — سامانه ارجان"
        toolbar={toolbar} error={L.error} pager={L.pager} onMore={L.more} loading={L.loading} unit="بیمه نامه">
        <div style={ui.splitWrap}>
          <div style={ui.topPane}>
            <Grid columns={cols} rows={L.data} rowKey="CarInsureId" selectedKey={sel?.CarInsureId} onSelect={setSel}
              moneyCols={['مبلغ بیمه', 'مالیات بر ارزش افزوده', 'جمع']} />
          </div>
          {req && (
            <div style={ui.bottomPane}>
              <div style={{ padding: '6px 10px', fontWeight: 700, fontSize: '12px', color: '#1a2f50' }}>
                ریز درخواست شماره {toFa(sel?.['شماره درخواست'])} تاریخ {toFa(sel?.['تاریخ درخواست'])}
              </div>
              <Grid columns={req.columns} rows={req.data} rowKey="CarInsureId" moneyCols={['مبلغ بیمه', 'مالیات بر ارزش افزوده', 'جمع']} />
            </div>
          )}
        </div>
      </ListPage>

      {(modal === 'new' || modal === 'edit') && (
        <Modal title={modal === 'new' ? '＋ بیمه نامه جدید' : '✎ ویرایش بیمه نامه'} onClose={() => setModal(null)} width="860px"
          footer={<>
            {newReq && fb.can('BTNOK') && <button onClick={newRequest} style={smallBtn('#6a1b9a')}>شماره درخواست جدید</button>}
            <button onClick={() => setModal(null)} style={ui.btnCancel}>لغو</button>
            {fb.can('BTNOK') && fb.can(modal === 'new' ? 'BTNNEW' : 'BTNEDIT') &&
              <button onClick={save} disabled={saving} style={ui.btnSave}>{saving ? '⏳ ...' : 'ثبت'}</button>}
          </>}>
          {err && <div style={{ ...ui.errBox, whiteSpace: 'pre-line' }}>⚠️ {err}</div>}
          <InsureForm form={form} F={F} showTax={meta.show_tax !== false} />
        </Modal>
      )}
      {modal === 'delete' && <DeleteDialog onConfirm={doDelete} onCancel={() => setModal(null)} />}
      {askConfirm && (
        <WarningDialog title="انتخاب کنید" lines={[]} confirmLabel="تاییدیه" cancelLabel="صورتجلسه مصرف"
          onConfirm={() => { setAskConfirm(false); report('tadarokat.car_insure_confirm', confirmParams(1)); }}
          onCancel={() => { setAskConfirm(false); report('tadarokat.car_insure_confirm', confirmParams(0)); }} />
      )}
      {msg && <MsgDialog text={msg} onClose={() => setMsg('')} />}
    </>
  );
}
